import React, { Component } from 'react';
import { Dropdown, Button, Icon } from 'semantic-ui-react'

class SelectOption extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value : props.value,
			editing : props.editButton ? false : true,
			resetKey : 0,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.value != this.props.value) {
			this.setState({value:this.props.value})
		}
	}

	render() {
		const { value, editing, resetKey } = this.state
		const { label, placeholder = 'Select', options = [], onSelect, onClear, noConfirm=false, multiple=false, confirmTitle = 'Confirm Change Access', name = label, clearable = true, loading = false } = this.props

		let val = options&&options.filter(k => k.key==value)
		val = val && val[0]

		if (!editing) {
			return <React.Fragment>
					{label&&<>{label}{" "}</>}
					<h5 style={{display:'inline'}}>{loading && <Icon name='spinner' loading /> || val&&val.text} {val&&val.subtext && <React.Fragment><br/><small>{val&&val.subtext}</small></React.Fragment>}</h5>
				{!this.props.readOnly && (
					<Button
						compact
						size='mini'
						onClick={_=>this.setState({editing:true})}>Edit</Button>

				)}
				</React.Fragment>
		}

		return (
			<Dropdown
					key={resetKey}
					fluid
					clearable={clearable}
					selection
					selectOnBlur={false}
					className="select-option"
					closeOnChange
					lazyLoad
					multiple={multiple}
					onChange={async (e,{value: newValue}) => {
						let val = null;
						if (multiple) {
							if (newValue.length === 0) {
								val = 'NONE';
							} else {
								val = '"' + newValue.map(v => {
									return options?.find(({key}) => key === v)?.text ?? '??'
								}).join(', ') + '"';
							}

						} else {
							val =  options&&options.filter(k => k.key==newValue)
							val = (val?.[0]?.text) ?? 'NONE';
						}

						const prevText = !multiple && options?.find(k => k.key == value)?.text;

						const confirmMsg = (!multiple && newValue === '')
							? `Remove ${name || 'value'}${prevText ? ` (${prevText})` : ''}`
							: prevText
								? `Update ${name || 'value'} from ${prevText} to ${val}`
								: `Update ${name || 'value'} to ${val}`;

						if (
							noConfirm || (
								await app.confirm(
									confirmTitle,
									confirmMsg
								)) == 'yes'
						) {
							this.setState({ value: newValue })
							if (newValue != '') {
								onSelect && onSelect(newValue)
							} else {
								onClear && onClear(newValue)
							}
						} else {
							// Declined - Dropdown tracks the clicked option internally regardless of the controlled
							// `value` prop, so remount it (via key change) to force it back to the actual value.
							this.setState(s => ({ resetKey: s.resetKey + 1 }))
						}

					}}
					search={(options, query) => {
						const q = query.toLowerCase()
					  	return options.filter(opt => opt.search.includes(q))
					}}
					options={options.map(o=>{
						return {
							key:o.key,
							value:o.value,
							search:`${o.text} ${o.subtext}`.toLowerCase(),
							text:<h5>{o.text}{o.subtext && <React.Fragment><br/><small>{o.subtext}</small></React.Fragment>}</h5>
						}
					})}
					placeholder={placeholder}
					value={value}
					loading={loading}
					disabled={loading}
				  />

		);
	}

}

export default SelectOption;
